import React, { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { store, persistor } from 'redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider as ReduxProvider } from 'react-redux';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ZipcodeListenerProvider } from 'components/Global/ZipcodeListenerProvider/ZipcodeListenerProvider';
import EVChargingLocator from 'standalone/EVChargingLocator/EVChargingLocator';
import { EVAutosListenerProvider } from 'components/Global/EVAutosListenerProvider/EVAutosListenerProvider';

const queryClient = new QueryClient();
const isHonda = process.env.REACT_APP_THEME === 'honda';

function ChargingLocatorApp() {
  return (
    <Suspense fallback={<></>}>
      <ReduxProvider store={store}>
        <PersistGate persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <ZipcodeListenerProvider />
            {isHonda && <EVAutosListenerProvider />}
            <EVChargingLocator />
            <ReactQueryDevtools position="top-right" />
          </QueryClientProvider>
        </PersistGate>
      </ReduxProvider>
    </Suspense>
  );
}

export default ChargingLocatorApp;
